import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DesignService, Design } from '../services/design.service';
import { AuthService } from '../components/services/auth.service';

@Component({
  selector: 'app-design-list',
  templateUrl: './design-list.component.html',
  styleUrls: ['./design-list.component.css']
})
export class DesignListComponent implements OnInit {
  designs: Design[] = [];
  loading = true;
  error = '';

  constructor(
    private designService: DesignService,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit() {
    const user = this.authService.getCurrentUser();
    const userId = user?.id ? String(user.id) : undefined;
    this.designService.getDesigns(userId).subscribe({
      next: (d) => { this.designs = d; this.loading = false; },
      error: () => { this.error = 'Failed to load designs.'; this.loading = false; }
    });
  }

  newDesign() {
    this.router.navigate(['/designs/new']);
  }

  editDesign(design: Design) {
    this.router.navigate(['/designs', design.id]);
  }

  deleteDesign(design: Design, e: Event) {
    e.stopPropagation();
    if (!confirm(`Delete "${design.name}"?`)) return;
    this.designService.deleteDesign(+design.id).subscribe({
      next: () => { this.designs = this.designs.filter(d => d.id !== design.id); }
    });
  }

  formatDate(dateStr?: string): string {
    if (!dateStr) return '';
    return new Date(dateStr).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  }
}
